import { TGetMeDto, TGetMeResDto } from "@/api/services/main/auth/dtos/get-me.dto";
import { TMatch } from "@/api/entities/matches.entity";
import { USER_TYPE } from "@/types/enum";

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

const MOCK_MATCH: TMatch = {
  id: 1,
  matchName: "株式会社テスト登録支援機関",
  licenseNumber: "20-00001",
  contractStatus: "during_contract",
  contractPlan: "standard",
  prefecture: "東京都",
  address: "渋谷区1-1-1",
  zipCode: "150-0001",
  city: "渋谷区",
  createdAt: "2024-01-01T00:00:00Z",
  updatedAt: "2024-01-01T00:00:00Z",
};

const MOCK_USER: TGetMeDto = {
  id: 1,
  fullName: "テスト ユーザー",
  email: "test@example.com",
  type: USER_TYPE.RSO_USER,
  rsoId: 1,
  match: MOCK_MATCH,
  isUser: true,
  createdAt: "2024-01-01T00:00:00Z",
  updatedAt: "2024-01-01T00:00:00Z",
};

export const getMeMock = async (): Promise<TGetMeResDto> => {
  await delay(100);

  return {
    data: MOCK_USER,
    message: "Success",
  };
};

export { MOCK_USER, MOCK_MATCH };
